export default __webpack_public_path__ + "images/purple-game-control.svg";